import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule, FormControlDirective, FormGroupDirective } from '@angular/forms'; /** for ngModel & forms **/


/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples
*/
import { NgZorroAntdModule } from 'app/ng-zorro.module';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgxChartsModule } from '@swimlane/ngx-charts'; /* ngx-charts */
import { OrgChartModule } from 'ng2-org-chart'; /* Org Hierarchy Chart */
import { registerLocaleData } from '@angular/common';
import { GlobalAppModule } from '../../global-app.module'
import { CustomPipesModule } from 'app/BaseFramework/shared/custom-pipes/custom-pipes.module';

//Shared Components
import { NewClientCaptureComponent } from './new-client-capture/new-client-capture.component';
import { AddressCaptureIndonesiaComponent } from './address-capture-indonesia/address-capture-indonesia.component';
import { ContactnumberCaptureComponent } from './contactnumber-capture/contactnumber-capture.component';
import { OccupationCaptureComponent } from './occupation-capture/occupation-capture.component';
import { IdentityCaptureComponent } from './identity-capture/identity-capture.component';
import { CoveragesComponent } from './coverages/coverages.component';
import { UISearchComponent } from './ui-search/ui-search.component';
import { BankDetailsComponent } from './bank-details/bank-details.component';
import { GenericZeroUiComponent } from './generic-zero-ui/generic-zero-ui.component';
import { ClientSearchComponent } from './client-search/client-search.component';
import { PolicySearchComponent } from './policy-search/policy-search.component';
import { UIMultirowBasicComponent } from './ui-multirow-basic/ui-multirow-basic.component';
import { UIAddressIndComponent } from './ui-address-ind/ui-address-ind.component'
import { NgApexchartsModule } from "ng-apexcharts";
import { NgChartsModule } from 'ng2-charts';


//Should be added for Translations to be loaded on Lazy Loads
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiLingualService } from 'app/BaseFramework/core/services';
import { ClaimsBasicDetailsComponent } from './claims-basic-details/claims-basic-details.component';
import { PoliceDetailsComponent } from './police-details/police-details.component';
import { InsuredDetailsComponent } from './insured-details/insured-details.component';
import { HospitalDetailsComponent } from './hospital-details/hospital-details.component';
import { DoctorDetailsComponent } from './doctor-details/doctor-details.component'
import { CapturedPolicyListComponent } from './captured-policy-list/captured-policy-list.component';
import { NzExplainWrapperComponent } from './field-specific-components/nz-explain-wrapper/nz-explain-wrapper.component';
import { GenericSearchComponent } from './generic-search/generic-search.component';
import { CapturedClientListComponent } from './captured-client-list/captured-client-list.component';
import { MulticaptureBankDetailsComponent } from './multicapture-bank-details/multicapture-bank-details.component';
import { ViewPolicySummaryComponent } from './view-policy-summary/view-policy-summary.component';
import { ViewProfileSummaryComponent } from './view-profile-summary/view-profile-summary.component';
import { ViewAllProfilesComponent } from './view-all-profiles/view-all-profiles.component'

import { CaptureClientDetailsComponent } from './capture-client-details/capture-client-details.component';
import { TransactionSummaryRibbonComponent } from './transaction-summary-ribbon/transaction-summary-ribbon.component';
import { ClaimsWorkflowAuditComponent } from './claims-workflow-audit/claims-workflow-audit.component';
import { ClaimsActivityTimelineComponent } from './claims-activity-timeline/claims-activity-timeline.component'
import { UiAnalyticsTabComponent } from './ui-analytics-tab/ui-analytics-tab.component';
import { InboxCardComponent } from './inbox-card/inbox-card.component';
import { TaskListFilter } from 'app/BaseFramework/shared/custom-pipes/taskListFilter';
/* Document Manager */
import { DocumentManagerComponent } from './document-manager/document-manager.component';
import { DocumentManagerDataService } from './document-manager/document-manager-data.service';
import { CorrespondenceHistoryComponent } from './correspondence-history/correspondence-history.component';
import { NotesManagerComponent } from './notes-manager/notes-manager.component';
import { ClaimWorksheetComponent } from './claim-worksheet/claim-worksheet.component';
import { OcrVerifierComponent } from './ocr-verifier/ocr-verifier.component';
/* RICH TEXT EDITOR -- DEMO -- CHANGE AS DESIRED (Quill)*/
import { AngularEditorModule } from '@kolkov/angular-editor';
/* PDF Reader */
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxCurrencyModule } from 'ngx-currency'
import { HospitalNestedTableComponent } from './hospital-nested-table/hospital-nested-table.component';
import { PayoutDetailsComponent } from './payout-details/payout-details.component';
import { ClaimDecisionComponent } from './claim-decision/claim-decision.component';
import { UnderwritingDecisionComponent } from './underwriting-decision/underwriting-decision.component'
import { ClaimsBenefitComponent } from './claims-benefit/claims-benefit.component';
import { ClaimsPaymentBreakupComponent } from './claims-payment-breakup/claims-payment-breakup.component';
import { IntimationBulkUploadComponent } from './intimation-bulk-upload/intimation-bulk-upload.component';
import { NewBulkComponent } from './new-bulk/new-bulk.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { SubmissionDataComponent } from './submission-data/submission-data.component';
import { ProposalQuestionnaireComponent } from './proposal-questionnaire/proposal-questionnaire.component';
import { ProductCoveragesComponent } from './product-coverages/product-coverages.component';
import { InsuredCoverageDecisionComponent } from './insured-coverage-decision/insured-coverage-decision.component';
import { RulesAutoComponent } from './rules-auto/rules-auto.component'
import { ExclusionsMultiAddPanelComponent } from './exclusions-multi-add-panel/exclusions-multi-add-panel.component';
import { OtherPolicyComponent } from './other-policy/other-policy.component';
import { UnderwritingWorksheetComponent } from './underwriting-worksheet/underwriting-worksheet.component';
import { UiAccordionSmallComponent } from './ui-accordion-small/ui-accordion-small.component';
import { DashboardComponent } from './dashboard/dashboard.component';
//import { ClickOutsideModule } from 'ng-click-outside';
import { AgentSearchComponent } from './agent-search/agent-search.component';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { environment } from 'environments/environment';
import { CapturedAgentListComponent } from './captured-agent-list/captured-agent-list.component';
import { CorrespondenceManagerComponent } from './correspondence-manager/correspondence-manager.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { UIAddressThaiComponent } from './ui-address-thailand/ui-address-thailand.component';
import { BillDetailsAdvancedComponent } from './bill-details-advanced/bill-details-advanced.component';
import { InputGridNestedComponent } from './input-grid-nested/input-grid-nested.component'

import { InputMaskAngularModule } from 'input-mask-angular';
// import { LatLongDetailsComponent } from './lat-long-details/lat-long-details.component';
import { LightGridComponent } from './light-grid/light-grid.component';
// import { SearchConfigurationComponent } from './search-configuration/search-configuration.component';
import { FWAAnalyticsComponent } from './fwa-analytics/fwa-analytics.component';

import { FraudRulesComponent } from './fraud-rules/fraud-rules.component';
import { UiRulesAutoComponent } from './ui-rules-auto/ui-rules-auto.component';
import { FwaDashboardComponent } from './fwa-dashboard/fwa-dashboard.component';
import { PaymentBreakupComponent } from './payment-breakup/payment-breakup.component';
import { ReceiptingComponent } from './receipting/receipting.component';
import { ViewReceiptComponent } from './view-receipt/view-receipt.component';
import { SearchReceiptComponent } from './search-receipt/search-receipt.component';
import { MedicalRiskComponent } from './medical-risk/medical-risk.component';
import { UiDraggableModalComponent } from './ui-draggable-modal/ui-draggable-modal.component';
import { SLADashboardComponent } from './sla-dashboard/sla-dashboard.component';
import { UWDashboardComponent } from './uw-dashboard/uw-dashboard.component';
import { OnlineMeetingComponent } from './online-meeting/online-meeting.component';
import { CustomerDashComponent } from './customer/customer-dash.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { ServicingRequestFormComponent } from './servicing-inbox/servicing-request-form.component';
import { ServicingInboxComponent } from './servicing-inbox/servicing-inbox.component';
import { ServicingCardComponent } from './servicing-inbox/servicing-card.component';
import { UiPolicySearchAddComponent } from './ui-policy-search-add/ui-policy-search-add.component';
import { PhoneListDetailsComponent } from './phone-list-details/phone-list-details.component';
import { EmailListDetailsComponent } from './email-list-details/email-list-details.component';
import { OcrDetailsComponent } from './ocr-details/ocr-details.component';
import { UiWorksheetComponent } from './ui-worksheet/ui-worksheet.component';
import { DataListComponent } from './data-list/data-list.component';
import { LabelViewComponent } from './label-view/label-view.component';
import { SearchAndLinkComponent } from './search-and-link/search-and-link.component';
import { UnderWriterDashboardComponent } from './under-writer-dashboard/under-writer-dashboard.component';
import { NzListModule } from 'ng-zorro-antd/list';
import { ProcessBulkUploadComponent } from './process-bulk-upload/process-bulk-upload.component';
import { StageTimelineComponent } from './stage-timeline/stage-timeline.component';
import { OrgHierarchyComponent } from './org-hierarchy/org-hierarchy.component';
import { RiskSummarizationComponent } from './risk-summarization/risk-summarization.component';
import { ApiDashboardComponent } from './api-dashboard/api-dashboard.component';

import { UnderwriterReviewComponent } from './underwriter-review/underwriter-review.component'
import { NBDashboardComponent } from './nb-dashboard/nb-dashboard.component';
import { PersonalizedViewComponent } from './personalized-view/personalized-view.component';
import { DndListModule } from 'ngx-drag-and-drop-lists';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';


import { EnlistClientRecordsComponent } from './enlist-client-records/enlist-client-records.component';
import { RegisterClientDetailsComponent } from './register-client-details/register-client-details.component';
import { MarkdownComponent } from './markdown/markdown.component';
import { MarkdownModule } from 'ngx-markdown';
import { ViewSummaryComponent } from './view-summary/view-summary.component';
import { SearchOCRIntimationComponent } from '../Claims/intimation/search-OCRintimation/search-OCRintimation.component';
import { OcrCaseCreationComponent } from './ocr-case-creation/ocr-case-creation.component';
import { RuleAuditComponent } from './rule-audit/rule-audit.component';
import { PcExpressionBuilderComponent } from './pc-expression-builder/pc-expression-builder.component';
import { ClientListComponent } from './client-list/client-list.component';
import { CollaborationModalComponent } from './collaboration-modal/collaboration-modal.component';
import { CollaborationComponent } from './collaboration/collaboration.component';
import { ReassignTaskComponent } from './reassign-task/reassign-task.component';


export const sharedComponentList = [
  NewClientCaptureComponent,
  AddressCaptureIndonesiaComponent,
  ContactnumberCaptureComponent,
  OccupationCaptureComponent,
  IdentityCaptureComponent,
  CoveragesComponent,
  UISearchComponent,
  BankDetailsComponent,
  GenericZeroUiComponent,
  ClientSearchComponent,
  PolicySearchComponent,
  ClaimsBasicDetailsComponent,
  PoliceDetailsComponent,
  InsuredDetailsComponent,
  HospitalDetailsComponent,
  DoctorDetailsComponent,
  CapturedPolicyListComponent,
  GenericSearchComponent,
  UIMultirowBasicComponent,
  UIAddressIndComponent,
  CapturedClientListComponent,
  MulticaptureBankDetailsComponent,
  ViewPolicySummaryComponent,
  ViewProfileSummaryComponent,
  ClaimsWorkflowAuditComponent,
  ClaimsActivityTimelineComponent,
  UiAnalyticsTabComponent,
  CaptureClientDetailsComponent,
  TransactionSummaryRibbonComponent,
  DocumentManagerComponent,
  CorrespondenceHistoryComponent,
  NotesManagerComponent,
  ClaimWorksheetComponent,
  HospitalNestedTableComponent,
  PayoutDetailsComponent,
  InboxCardComponent,
  ClaimDecisionComponent,
  ClaimsBenefitComponent,
  ClaimsPaymentBreakupComponent,
  IntimationBulkUploadComponent,
  NewBulkComponent,
  OcrVerifierComponent,
  InputGridNestedComponent,
  //field-specific-components
  NzExplainWrapperComponent,
  ProductDetailsComponent,
  ProductCoveragesComponent,
  SubmissionDataComponent,
  ProposalQuestionnaireComponent,
  UnderwritingDecisionComponent,
  InsuredCoverageDecisionComponent,
  RulesAutoComponent,
  ExclusionsMultiAddPanelComponent,
  ViewAllProfilesComponent,
  OtherPolicyComponent,
  UnderwritingWorksheetComponent,
  UiAccordionSmallComponent,
  DashboardComponent,
  DynamicFormComponent,
  CorrespondenceManagerComponent,
  AgentSearchComponent,
  CapturedAgentListComponent,
  QuestionnaireComponent,
  UIAddressThaiComponent,
  BillDetailsAdvancedComponent,
  InputGridNestedComponent,
  BillDetailsAdvancedComponent,
  RulesAutoComponent,
  QuestionnaireComponent,
  // LatLongDetailsComponent,
  LightGridComponent,
  FraudRulesComponent,
  UiRulesAutoComponent,  
  FwaDashboardComponent,
  ReceiptingComponent,
  PaymentBreakupComponent,
  //SearchConfigurationComponent,
  ViewReceiptComponent,
  SearchReceiptComponent,
  MedicalRiskComponent,
  UiDraggableModalComponent,
  SLADashboardComponent,
  UWDashboardComponent,
  OnlineMeetingComponent,
  CustomerDashComponent,
  CustomerDetailsComponent,
  ServicingRequestFormComponent,
  ServicingInboxComponent,
  ServicingCardComponent,
  UiPolicySearchAddComponent,
  PhoneListDetailsComponent,
  EmailListDetailsComponent,
  OcrDetailsComponent,
  UiWorksheetComponent,
  DataListComponent,
  FWAAnalyticsComponent,
  LabelViewComponent,
  SearchAndLinkComponent,
  UnderWriterDashboardComponent,
  ProcessBulkUploadComponent,
  StageTimelineComponent,
  OrgHierarchyComponent,
  RiskSummarizationComponent,
  ApiDashboardComponent,
  UnderwriterReviewComponent,
  NBDashboardComponent,
  PersonalizedViewComponent,
  VehicleDetailsComponent,  
  EnlistClientRecordsComponent,
  RegisterClientDetailsComponent,
  MarkdownComponent,
  ViewSummaryComponent,
  SearchOCRIntimationComponent,
  OcrCaseCreationComponent,
  RuleAuditComponent,
  PcExpressionBuilderComponent,
  ClientListComponent,
  CollaborationModalComponent,
  CollaborationComponent,
  ReassignTaskComponent
];

@NgModule({
  imports: [
    CommonModule,
    AngularEditorModule,
    TranslateModule.forChild({
      isolate: true
    }),
    NgZorroAntdModule,
    NgxCurrencyModule,
    NzIconModule,
    PdfViewerModule,
    FormsModule,
    ReactiveFormsModule,
    CustomPipesModule,
    //ClickOutsideModule,
    NgxChartsModule,
    NgxCurrencyModule,
    InputMaskAngularModule,
    NzListModule,
    OrgChartModule,
    NgChartsModule,
    NgApexchartsModule,
    DndListModule,
    MarkdownModule.forRoot()
  ],
  providers: [FormControlDirective, FormGroupDirective, DocumentManagerDataService],
  declarations: [...sharedComponentList],
  exports: [...sharedComponentList, TranslateModule]
})
export class SharedComponentsModule {

  //Should be added for Translations to be loaded on Lazy Loads
  constructor(private translateService: TranslateService,
    private multiLingualService: MultiLingualService) {
    this.multiLingualService.resetLanguageLocales(this.translateService)
  }


}
